var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGreen2Faa7Dc1874F8E87Bca1485Cf7Ba39Cf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.667 3.00195C17.0985 3.00195 3.66699 16.4334 3.66699 33.002C3.66699 49.5706 17.0985 63.002 33.667 63.002C40.8709 63.002 47.4816 60.4629 52.6532 56.2308L61.5457 65.1233C62.7172 66.2948 64.6167 66.2948 65.7883 65.1233C66.9599 63.9517 66.9599 62.0522 65.7883 60.8806L56.8959 51.9882C61.1279 46.8166 63.667 40.2058 63.667 33.002C63.667 16.4334 50.2357 3.00195 33.667 3.00195ZM9.66699 33.002C9.66699 19.7471 20.4122 9.00195 33.667 9.00195C46.9219 9.00195 57.667 19.7471 57.667 33.002C57.667 46.2569 46.9219 57.002 33.667 57.002C20.4122 57.002 9.66699 46.2569 9.66699 33.002Z",
    fill: "#2DC8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.667 3.00195C17.0985 3.00195 3.66699 16.4334 3.66699 33.002C3.66699 49.5706 17.0985 63.002 33.667 63.002C40.8709 63.002 47.4816 60.4629 52.6532 56.2308L61.5457 65.1233C62.7172 66.2948 64.6167 66.2948 65.7883 65.1233C66.9599 63.9517 66.9599 62.0522 65.7883 60.8806L56.8959 51.9882C61.1279 46.8166 63.667 40.2058 63.667 33.002C63.667 16.4334 50.2357 3.00195 33.667 3.00195ZM9.66699 33.002C9.66699 19.7471 20.4122 9.00195 33.667 9.00195C46.9219 9.00195 57.667 19.7471 57.667 33.002C57.667 46.2569 46.9219 57.002 33.667 57.002C20.4122 57.002 9.66699 46.2569 9.66699 33.002Z",
    fill: "url(#paint0_linear_272_2981)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_2981",
    x1: 52.7748,
    y1: -84.5428,
    x2: -62.0676,
    y2: 8.58076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206376,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359714,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833386,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen2Faa7Dc1874F8E87Bca1485Cf7Ba39Cf);
export default __webpack_public_path__ + "static/media/search-green.2faa7dc1874f8e87bca1485cf7ba39cf.767aa386f9c54d098191e2704829877a.svg";
export { ForwardRef as ReactComponent };